import type { FeedProductInterface, FormattedFeedProductType } from '@/types'
import getProductKey from '@/utils/products/getProductKey'

export class ExpandedRowsService {
  calculate(
    products: FormattedFeedProductType[],
    productInfoToCartPresence: Record<string, number>
  ): string[] {
    if (!products || products.length === 0) return []

    const expandedRows: string[] = []

    products.forEach((product, index) => {
      const productKey = String(getProductKey(product))

      const isFirstItem = index === 0

      const hasServerCartInfo = this.hasCartInfoInProduct(product)

      const hasLocalCartPresence = Object.keys(productInfoToCartPresence).some(
        (key) => key.startsWith(`${product.nomenclatureDto.code} `)
      )

      if (isFirstItem || hasServerCartInfo || hasLocalCartPresence) {
        expandedRows.push(productKey)
      }
    })

    return Array.from(new Set(expandedRows))
  }

  private hasCartInfoInProduct(product: FormattedFeedProductType): boolean {
    const check = (item: FeedProductInterface) =>
      item.suppliersStock?.some((ss) =>
        ss.stock?.some(
          (s) =>
            (s.cartInfo && s.cartInfo.quantity > 0) ||
            (s.quantityInCart && s.quantityInCart > 0)
        )
      ) ?? false

    if (check(product)) return true
    return product.children?.some((child) => check(child)) ?? false
  }
}
